import { CSSProperties } from 'react';

const GoogleStoreIcon = (props: { style?: CSSProperties; className?: string }) => (
  <svg
    id='google_svg__artwork'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 135 40'
    width='133'
    height='40'
    {...props}
  >
    <defs>
      <linearGradient
        id='google_svg__linear-gradient'
        x1={21.8}
        y1={172.06}
        x2={5.02}
        y2={155.28}
        gradientTransform='matrix(1 0 0 -1 0 180.8)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0} stopColor='#00a0ff' />
        <stop offset={0.01} stopColor='#00a1ff' />
        <stop offset={0.26} stopColor='#00beff' />
        <stop offset={0.51} stopColor='#00d2ff' />
        <stop offset={0.76} stopColor='#00dfff' />
        <stop offset={1} stopColor='#00e3ff' />
      </linearGradient>
      <linearGradient
        id='google_svg__linear-gradient-2'
        x1={33.83}
        y1={160.77}
        x2={9.64}
        y2={160.77}
        gradientTransform='matrix(1 0 0 -1 0 180.8)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0} stopColor='#ffe000' />
        <stop offset={0.41} stopColor='#ffbd00' />
        <stop offset={0.78} stopColor='orange' />
        <stop offset={1} stopColor='#ff9c00' />
      </linearGradient>
      <linearGradient
        id='google_svg__linear-gradient-3'
        x1={24.83}
        y1={158.48}
        x2={2.07}
        y2={135.72}
        gradientTransform='matrix(1 0 0 -1 0 180.8)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0} stopColor='#ff3a44' />
        <stop offset={1} stopColor='#c31162' />
      </linearGradient>
      <linearGradient
        id='google_svg__linear-gradient-4'
        x1={7.3}
        y1={180.6}
        x2={17.46}
        y2={170.44}
        gradientTransform='matrix(1 0 0 -1 0 180.8)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0} stopColor='#32a071' />
        <stop offset={0.07} stopColor='#2da771' />
        <stop offset={0.48} stopColor='#15cf74' />
        <stop offset={0.8} stopColor='#06e775' />
        <stop offset={1} stopColor='#00f076' />
      </linearGradient>
      <style>
        {
          '.google_svg__cls-2{fill:#fff;stroke:#fff;stroke-miterlimit:10;stroke-width:.2px}.google_svg__cls-9{isolation:isolate;opacity:.12}'
        }
      </style>
    </defs>
    <rect width={135} height={40} rx={5} />
    <path
      d='M130 .82A4.21 4.21 0 01134.2 5v30a4.2 4.2 0 01-4.2 4.2H5A4.2 4.2 0 01.8 35V5A4.21 4.21 0 015 .82h125m0-.8H5A5 5 0 000 5v30a5 5 0 005 5h125a5 5 0 005-5V5a5 5 0 00-5-5z'
      transform='translate(0 -.02)'
      fill='#a6a6a6'
    />
    <path
      className='google_svg__cls-2'
      d='M47.42 10.27a2.71 2.71 0 01-.75 2 2.91 2.91 0 01-2.2.89A3.09 3.09 0 0141.35 10a3.09 3.09 0 013.12-3.13 3 3 0 011.23.25 2.54 2.54 0 01.94.67l-.53.53a2 2 0 00-1.64-.71A2.31 2.31 0 0042.14 10a2.29 2.29 0 00.69 1.73 2.27 2.27 0 001.64.67 2.24 2.24 0 001.67-.67 1.93 1.93 0 00.51-1.21h-2.18v-.71h2.91a3.73 3.73 0 01.04.46zM52 7.76h-2.7v1.9h2.46v.72H49.3v1.91H52V13h-3.48V7H52zM55.28 13h-.77V7.76h-1.68V7H57v.74h-1.72zM59.94 13V7h.77v6zM64.13 13h-.77V7.76h-1.68V7h4.12v.74h-1.67zM73.61 12.25a3.11 3.11 0 01-4.4 0 3.08 3.08 0 01-.88-2.25 3.07 3.07 0 01.88-2.22 2.93 2.93 0 012.2-.91 3 3 0 012.2.91 3.07 3.07 0 01.88 2.22 3.08 3.08 0 01-.88 2.25zm-3.83-.5a2.32 2.32 0 003.26 0 2.38 2.38 0 00.67-1.75A2.38 2.38 0 0073 8.3a2.32 2.32 0 00-3.26 0 2.38 2.38 0 00-.63 1.7 2.38 2.38 0 00.67 1.75zM75.58 13V7h.93l2.92 4.67V7h.77v6h-.8l-3.05-4.87V13z'
      transform='translate(0 -.02)'
    />
    <path
      d='M68.14 21.78A4.25 4.25 0 1072.41 26a4.18 4.18 0 00-4.27-4.22zm0 6.83a2.59 2.59 0 112.4-2.61 2.46 2.46 0 01-2.4 2.61zm-9.32-6.83A4.25 4.25 0 1063.09 26a4.19 4.19 0 00-4.27-4.22zm0 6.83a2.59 2.59 0 112.4-2.61 2.46 2.46 0 01-2.4 2.61zm-11.08-5.53v1.8h4.32a3.83 3.83 0 01-1 2.28 4.46 4.46 0 01-3.34 1.32 4.8 4.8 0 010-9.6A4.63 4.63 0 0151 20.16l1.27-1.27a6.3 6.3 0 00-4.53-1.82 6.61 6.61 0 100 13.21 6 6 0 004.61-1.85 6 6 0 001.56-4.22 6.31 6.31 0 00-.09-1.13zm45.31 1.4a3.94 3.94 0 00-3.64-2.7 4 4 0 00-4 4.25 4.16 4.16 0 004.22 4.25 4.21 4.21 0 003.54-1.88l-1.45-1a2.42 2.42 0 01-2.09 1.18 2.16 2.16 0 01-2.06-1.29L93.25 25zm-5.8 1.42a2.33 2.33 0 012.23-2.48 1.64 1.64 0 011.57.9zM82.63 30h1.87V17.52h-1.87zm-3.06-7.29h-.07a2.94 2.94 0 00-2.24-.95 4.25 4.25 0 000 8.5 2.91 2.91 0 002.24-1h.07v.61a2.18 2.18 0 01-2.27 2.49 2.36 2.36 0 01-2.15-1.51l-1.62.68a4 4 0 003.77 2.57c2.19 0 4-1.29 4-4.43V22h-1.73zm-2.15 5.88a2.59 2.59 0 010-5.16A2.4 2.4 0 0179.7 26a2.38 2.38 0 01-2.28 2.61zm24.39-11.09h-4.48V30h1.87v-4.71h2.61a3.89 3.89 0 100-7.77zm0 6H99.2v-4.24h2.65a2.15 2.15 0 110 4.29zm11.54-1.8a3.5 3.5 0 00-3.33 1.92l1.65.69a2 2 0 013.67.69v.13a4.18 4.18 0 00-1.95-.48c-1.78 0-3.6 1-3.6 2.81a2.89 2.89 0 003.11 2.75 2.64 2.64 0 002.42-1.21h.06v1h1.8v-4.79c0-2.21-1.66-3.46-3.79-3.46zm-.23 6.85c-.61 0-1.46-.3-1.46-1.06 0-1 1.06-1.33 2-1.33a3.22 3.22 0 011.7.42 2.26 2.26 0 01-2.2 2.02zM123.74 22l-2.14 5.42h-.06L119.32 22h-2l3.33 7.57-1.9 4.21h2L125.82 22zm-16.8 8h1.86V17.52h-1.86z'
      transform='translate(0 -.02)'
      fill='#fff'
    />
    <path
      d='M10.44 7.56A2 2 0 0010 9v22.08a2 2 0 00.47 1.41l.07.07L22.9 20.17v-.29L10.51 7.49z'
      transform='translate(0 -.02)'
      fill='url(#google_svg__linear-gradient)'
    />
    <path
      d='M27 24.3l-4.1-4.13v-.29l4.1-4.13.09.05L32 18.58c1.4.8 1.4 2.09 0 2.89l-4.89 2.78z'
      transform='translate(0 -.02)'
      fill='url(#google_svg__linear-gradient-2)'
    />
    <path
      d='M27.12 24.25L22.9 20 10.44 32.49a1.61 1.61 0 002.07.06l14.61-8.3'
      transform='translate(0 -.02)'
      fill='url(#google_svg__linear-gradient-3)'
    />
    <path
      d='M27.12 15.8L12.51 7.5a1.61 1.61 0 00-2.07.06L22.9 20z'
      transform='translate(0 -.02)'
      fill='url(#google_svg__linear-gradient-4)'
    />
    <path
      d='M27 24.16L12.51 32.4a1.66 1.66 0 01-2 0l-.07.08.07.07a1.66 1.66 0 002 0l14.61-8.3z'
      transform='translate(0 -.02)'
      style={{
        isolation: 'isolate',
      }}
      opacity={0.2}
    />
    <path
      className='google_svg__cls-9'
      d='M10.44 32.34a2 2 0 01-.47-1.4v.14a2 2 0 00.47 1.41l.07-.08zM32 21.32l-5 2.84.09.09L32 21.47A1.76 1.76 0 0033.06 20 1.85 1.85 0 0132 21.32z'
      transform='translate(0 -.02)'
    />
    <path
      d='M12.51 7.65L32 18.73A1.85 1.85 0 0133.06 20 1.76 1.76 0 0032 18.58L12.51 7.5C11.12 6.71 10 7.37 10 9v.14c0-1.63 1.12-2.29 2.51-1.49z'
      transform='translate(0 -.02)'
      style={{
        isolation: 'isolate',
      }}
      opacity={0.25}
      fill='#fff'
    />
  </svg>
);

export default GoogleStoreIcon;
